import { render } from "./DisplayRules.vue?vue&type=template&id=33cb8b84"
import script from "./DisplayRules.vue?vue&type=script&lang=js"
export * from "./DisplayRules.vue?vue&type=script&lang=js"

import "./DisplayRules.vue?vue&type=style&index=0&id=33cb8b84&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__